import React, { FC, useEffect, useState } from "react";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/high-res.css";
import style from "./style.module.scss";
import validationError from "../../assets/images/validationError.svg";
import de from "react-phone-input-2/lang/de.json";

interface IPhoneInput {
  id: string;
  type: string;
  label?: string;
  isDisabled?: boolean;
  width?: string;
  isTouched?: boolean;
  onChange: (str: string) => void;
  onBlur?: (e: React.FocusEvent<any>) => void;
  error?: string;
  value: string;
  autoComplete?: string | undefined;
}

export const CustomPhoneInputV2: FC<IPhoneInput> = ({
  id,
  type,
  label,
  isDisabled = false,
  width,
  isTouched = false,
  onBlur,
  onChange,
  error = "",
  value,
  autoComplete = "off",
}: IPhoneInput) => {
  const [country, setCounty] = useState("Deutschland");
  // const [field, meta, helpers] = useField({
  //   name,
  //   type,
  // });

  useEffect(() => {
    const flag = document.getElementsByClassName("flag")[0];

    if (flag) {
      flag.setAttribute("role", "img");
      flag.setAttribute("aria-label", `${country}-Flagge`);
      flag.setAttribute("alt", `${country}-Flagge`);
    }
  }, [country]);

  return (
    <div
      className={`${style.input_wrapper}
        ${isTouched && error ? style.input_wrapperWithWarning : ""}
        `}
      style={{
        opacity: isDisabled ? 0.5 : 1,
        width: width ? width : "",
      }}
    >
      {label ? (
        <label
          className={`${style.label} ${
            isTouched && error && !isDisabled ? style.labelWithWarning : ""
          }`}
          htmlFor={id}
        >
          {label}
        </label>
      ) : null}
      <PhoneInput
        country={"de"}
        localization={de}
        value={value ?? ""}
        disabled={isDisabled}
        onChange={(value, data) => {
          if (isDisabled) {
            return;
          }
          if ((data as CountryData) && (data as CountryData).name) {
            setCounty((data as CountryData).name);
          }
          onChange(value);
        }}
        inputClass={`${style.phoneInput_wrapper}  ${
          isDisabled ? style.disabledCustomInput : ""
        } ${
          isTouched && error && !isDisabled ? style.customInputWithWarning : ""
        }`}
        containerClass={style.customContainer}
        buttonClass={`${style.customBtn} ${
          isTouched && error ? style.customBtnWithError : ""
        }`}
        dropdownClass={style.dropdown}
        onBlur={onBlur}
        inputProps={{
          name: id,
          type: type,
          "aria-label": "Ländervorwahl auswählen",
          id,
          "aria-invalid":
            isTouched && error && !value && !isDisabled ? true : undefined,
          "aria-describedby": `${id}-error`,
          autoComplete: autoComplete,
        }}
        placeholder="+49 1234 567890"
      />
      {/* {isTouched && error && !isDisabled && ( */}
      <div
        className={`${style.errorMessage} ${
          isTouched && error && !isDisabled ? null : style.disabledErrorMessage
        }`}
        id={`${id}-error`}
        role={isTouched && error && !isDisabled ? "alert" : undefined}
      >
        {error}
      </div>
      {/* )} */}
      {/* {isTouched && error && !isDisabled && ( */}
      <img
        src={validationError}
        className={`${style.warningImg} ${
          isTouched && error && !isDisabled ? null : style.disabledErrorMessage
        }`}
        style={{
          top: label ? "44px" : "7px",
        }}
      />
      {/* )} */}
    </div>
  );
};
